import React, { useState } from 'react'
import { Grid, Typography, IconButton, Collapse, Box, useTheme } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'

const GenericSectionHeader = ({ title, children, collapse = true }) => {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(true)

  const handleToggle = () => {
    if (collapse) {
      setIsOpen(prev => !prev)
    }
  }

  const contentBoxSx = {
    p: '20px 16px',
    backgroundColor: 'background.paper',
    borderRadius: '0 0 8px 8px',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderTop: 'none'
  }

  return (
    <>
      {/* Header */}
      <Grid
        container
        alignItems='center'
        onClick={handleToggle}
        sx={{
          p: '12px 16px',
          backgroundColor: theme.palette.grey[50],
          cursor: collapse ? 'pointer' : 'default',
          '&:hover': collapse ? { backgroundColor: theme.palette.grey[100] } : {},
          borderRadius: '8px 8px 0 0',
          mb: '2px',
        }}
      >
        {collapse && (
          <IconButton size='small' sx={{ color: 'primary.dark', mr: 1, p: 0 }}>
            {isOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
        <Typography variant='subtitle1' sx={{ fontWeight: 'bold', color: 'primary.main', flexGrow: 1 }}>
          {title}
        </Typography>
      </Grid>

      {/* Content */}
      {collapse ? (
        <Collapse in={isOpen}>
          <Box sx={contentBoxSx}>{children}</Box>
        </Collapse>
      ) : (
        <Box sx={contentBoxSx}>{children}</Box>
      )}
    </>
  )
}

export default GenericSectionHeader
